import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-secondary-brand',
  templateUrl: './secondary-brand.component.html',
  styleUrls: ['./secondary-brand.component.scss']
})
export class SecondaryBrandComponent implements OnInit, OnChanges {
  listOfSecondaryBrands: any;
  brandSuggestion1: any;
  modelSuggestion: any;
  allModels: any;
  brandName: any;
  modelName: any;
  secondaryBrandSuggestion: any = [];
  category:any;
  categories:any=[];
  @Input()
  set secondaryBrandData (listOfSecondaryBrands: any) {
    this.listOfSecondaryBrands = listOfSecondaryBrands ? listOfSecondaryBrands : [];
  }

  @Input()
  set listOfAllModels (modelList: any) {
    this.allModels = modelList ? modelList : [];
  }

  @Input() brandSuggestionList: any;

  @Input()
  set brandCategory(cat:any){
   this.category =cat;
  }

  @Input()
  set brandCategories(cats:any){
   this.categories =cats;
  }

  @Input()
  set modelSuggestionList (modelSuggestionList: any) {
    this.modelSuggestion = modelSuggestionList ? modelSuggestionList : [];
  }
  
  @Input()
  set brand (brand: any) {
    this.brandName = brand ? brand : '';
  }

//  add model name also need to update brand and model suggestion and also upadte on delete
  @Input()
  set model (model: any) {
    this.modelName = model ? model : '';
  }
  @Input() storyEditMode : boolean;

  @Output() secondaryBrandChanged: EventEmitter<number> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.prepareSecondaryBrandsList();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.brandSuggestion1 = this.brandSuggestionList ? this.brandSuggestionList : [];
    this.prepareSecondaryBrandsList();
  }

  prepareSecondaryBrandsList() {
    // console.log("prepareSecondaryBrandsList");
    this.secondaryBrandSuggestion = this.brandSuggestion1;
    // console.log(this.modelSuggestion);
    // console.log(this.brandName);
    if(this.modelSuggestion.hasOwnProperty(this.brandName)){
      // console.log(this.modelSuggestion);
      // console.log(this.modelSuggestion[this.brandName]);
      let modelList = this.modelSuggestion[this.brandName];
      // console.log(modelList);
      if(modelList.indexOf(this.modelName) > -1) {
        modelList.splice(modelList.indexOf(this.modelName), 1);
        // console.log(modelList);
        this.modelSuggestion[this.brandName] = modelList;
      }
    }
    // console.log(this.listOfSecondaryBrands)
    for(let i of this.listOfSecondaryBrands) {
      // console.log(i)
      if(i['model'] != "") {
        // console.log(i['brand']);
        if(this.modelSuggestion.hasOwnProperty(i['brand'])){
          // console.log(this.modelSuggestion);
          // console.log(this.modelSuggestion[i['brand']]);
          let modelList = this.modelSuggestion[i['brand']];
          // console.log(modelList);
          if(modelList.indexOf(i['model']) > -1) {
            modelList.splice(modelList.indexOf(i['model']), 1);
            // console.log(modelList);
            this.modelSuggestion[i['brand']] = modelList;
          }
        }
      }
    }
  }

  addNewBrand() {
    this.listOfSecondaryBrands.push(
      {
        "brand":"",
        "model":""
      }
    )
    this.prepareSecondaryBrandsList();
  }
  deleteBrand(addedBrand: any) {
    // add back to list while deleting
    if(addedBrand['model'] != ""){
      // this.secondaryBrandSuggestion.push(addedBrand['brand']);
      if(this.modelSuggestion[addedBrand['brand']].indexOf(addedBrand['model']) === -1)
        this.modelSuggestion[addedBrand['brand']].push(addedBrand['model']);
    }
    this.listOfSecondaryBrands.splice(this.listOfSecondaryBrands.indexOf(addedBrand),1)
    // console.log(this.listOfSecondaryBrands.length)
    if(this.listOfSecondaryBrands.length == 0) {
      if(this.modelSuggestion[this.brandName].indexOf(this.modelName) === -1)
        this.modelSuggestion[this.brandName].push(this.modelName);
    }
  }


  brandChangedHandler(ev)
  {
    this.prepareSecondaryBrandsList();
    this.secondaryBrandChanged.emit(ev)
  }

}
